/**
 * 链接卡片标记（2026-07-27 甲方需求）：把「段落内独占一行」的链接标记为
 * `rich-link-card`，配合 rich-text.css 渲染成微信风格卡片。
 *
 * CSS 的 `:only-child` 只数元素节点、忽略文本节点，无法区分「整段只有
 * 一个链接」与「句内行内链接」，因此独占判定放在 JS 侧做：
 * 父 `<p>` 的子节点除该 `<a>` 外只允许空白文本节点。含图片的链接
 * （灯箱优先场景）不标记，维持原有图片块布局。
 */
export const LINK_CARD_CLASS = 'rich-link-card';

export function markStandaloneLinkCards(root: HTMLElement): void {
  root.querySelectorAll('p > a').forEach((anchor) => {
    const paragraph = anchor.parentElement;
    if (!paragraph) {
      return;
    }
    const standalone = Array.from(paragraph.childNodes).every(
      (node) => node === anchor || isWhitespaceText(node),
    );
    const hasImage = anchor.querySelector('img') !== null;
    anchor.classList.toggle(LINK_CARD_CLASS, standalone && !hasImage);
  });
}

function isWhitespaceText(node: ChildNode): boolean {
  return node.nodeType === Node.TEXT_NODE && !(node.textContent ?? '').trim();
}
